import { useEffect, useRef, useState } from "react";
import styles from "./styles.module.css";
import { ReactComponent as BackArrowSvg } from "../../../../assets/backarrow.svg";
import { Button, Form, Label } from "semantic-ui-react";
import { Formik, ErrorMessage } from "formik";
import {
  InputTemp,
  SelectTemp,
  VendorInputTemp,
} from "../../../../app/common/form/Custom";
import { vendorSchema } from "../../../../app/validation/validationSchema";
import MyTextArea from "../../../../app/common/form/MyTextArea";
import {
  Checkbox,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import UploadImageTemp from "../../../../app/common/form/Custom/UploadImageTemp";
import Modal from "../../../../app/common/modals/Custom";
import { ReactComponent as ThumbsUpSvg } from "../../../../assets/navbericon/thumbsup.svg";
import { useNavigate, useParams } from "react-router-dom";
import { useStore } from "../../../../app/stores/store";
import Loading from "../../../../app/layout/Loading";
import { observer } from "mobx-react-lite";
// import {ExampleFile as File} from "../../../../assets/ProductExample.csv"
import responseCodes, {
  handleStateChange,
  handleStateChange2,
  handleStateChange3,
  handleStateChange4,
  handleStateDecimalToPrice,
} from "../../../../app/common/hooks/helpers";
import { toast } from "react-toastify";
import { validate as uuidValidate } from "uuid";

const UpdateProduct = () => {
  const params = useParams();
  const productId = params.id!;
  const [modal, setModal] = useState("");
  const navigate = useNavigate();
  const [imageUploadTypes, setImageUploadTypes] = useState<string[]>([
    "",
    "",
    "",
    "",
    "",
  ]);
  // const [imageUpload, setImageUpload] = useState<string[]>([]);
  const { productStore } = useStore();
  const {
    getProductCategories,
    getProductBrands,
    categoryList,
    brandsList,
    inverterTypesList,
    imageUpload,
    setImageUpload,
    loading,
    guidStatus,
    fetchProductAsync,
    currentProduct,
    setGuidStatus,
    getUrl,
    imageUploadIds,
    updateProduct,
    getInverterTypes,
  } = productStore;
  const [vat, setVat] = useState(false);
  const imageHandler = (e: any, index?: number) => {
    try {
      const UPLOAD_LIMIT = Number(process.env.REACT_APP_UPLOAD_LIMIT);
      const file = e.target.files && e.target.files[0];
      if (!file) return;
      if (file.size > UPLOAD_LIMIT) {
        toast.error('File too large. Maximum upload size is 1 MB.');
        return;
      }
      const reader = new FileReader();
      reader.onload = () => {
        if (reader.readyState === 2) {
          if (index !== undefined) {
            const newImageUpload = [...imageUpload];
            newImageUpload[index] = reader.result!.toString();
            setImageUpload(newImageUpload);
            const newImageUploadTypes = [...imageUploadTypes];
            newImageUploadTypes[index] = `${index},${file.type}`;
            // console.log(imageUpload)
            setImageUploadTypes(newImageUploadTypes);
          } else
            setImageUpload([
              ...imageUpload,
              reader.result!.toString(),
            ]);
        }
      };
      reader.readAsDataURL(file);
    } catch {
      // console.log("none");
      // setImageUpload([]);
    }
  };

  const isHttpUrl = (value: string) => /^https?:\/\//i.test(value);
  const isDataUrl = (value: string) => /^data:/i.test(value);

  const detectImageMime = (base64: string): string => {
    const sig = base64.slice(0, 24);
    if (sig.startsWith("iVBORw0KGgo")) return "image/png";
    if (sig.startsWith("/9j/")) return "image/jpeg";
    if (sig.startsWith("R0lGOD")) return "image/gif";
    if (sig.startsWith("UklGR")) return "image/webp";
    return "image/jpeg";
  };

  const resolveImageSrc = (value?: string | null): string | undefined => {
    if (!value) return undefined;
    const trimmed = value.trim();
    if (isHttpUrl(trimmed) || isDataUrl(trimmed)) return trimmed;
    const cleaned = trimmed.replace(/\s/g, "");
    const mime = detectImageMime(cleaned);
    return `data:${mime};base64,${cleaned}`;
  };
  const saveForm = async (values: any) => {
    // console.log(values)
    // console.log(currentProduct, "current-product");
    // console.log(currentProduct?.productImages)
    const urlList: string[] = [];
    // console.log(imageUpload, "images")
    try {
      // for (let i = 0; i < imageUpload.length; i++) {
      //   if (imageUpload[i].includes("https://")) {
      //     urlList.push(imageUpload[i]);
      //   } else {
      //     const imagePayload = {
      //       postedFilebase64: imageUpload[i],
      //       documentName: `ProductImage${Math.floor(Math.random() * 6) + 1}`,
      //       filetype: imageUploadTypes
      //         .filter((imageUploadType) => {
      //           return imageUploadType && imageUploadType?.split(",")[0] === i.toString();
      //         })[0]?.split(",")[0]
      //         ? imageUploadTypes
      //             .filter((imageUploadType) => {
      //               return imageUploadType && imageUploadType?.split(",")[0] === i.toString();
      //             })[0]?.split(",")[1]
      //         : "image/jpeg",
      //     };
      //     await getUrl(imagePayload).then((data) => urlList.push(data.data));
      //   }
      // }
      if (imageUpload.length > 0) {
        const payload = {
          ...values,
          minIvtCap: String(values.minIvtCap),
          batType: String(values.batType),
          batTypeValue: String(values.batTypeValue),
          multipleProductImageUrl: imageUpload,
          multipleProductImageIds: imageUploadIds,
          productPrimaryImageUrl: imageUpload[0],
          productCurrentPrice: Number.parseFloat(
            values.productCurrentPrice?.split(",")?.join("")
          ),
          productPreviousPrice: Number.parseFloat(
            values.productPreviousPrice?.split(",")?.join("")
          ),
          productQuantity: Number.parseFloat(
            values.productQuantity?.split(",")?.join("")
          ),
          weight: Number.parseFloat(values.weight?.split(",")?.join("")),
        };
        // console.log(payload);
        await updateProduct(payload).then((res) => {
          if (res?.responseCode === responseCodes.response_00) {
            toast.info(res.responseMessage);
            setModal("success");
          }
        });
      }
    } catch (error) {
      toast.error(String(error));
      // console.log(error)
      return error;
    }
  };

  var initialValues = {
    productId: currentProduct ? currentProduct.productId : "",
    productName: currentProduct ? currentProduct.productName : "",
    rating: currentProduct ? currentProduct.rating : "",
    brandId: currentProduct ? currentProduct.brandId : "",
    categoryId: currentProduct ? currentProduct.categoryId : "",
    vendorId: currentProduct ? currentProduct.vendorId : "",
    subCategoryId: currentProduct ? currentProduct.subCategoryId : "",
    productPrimaryImageUrl: currentProduct
      ? currentProduct.productPrimaryImageUrl
      : "",
    multipleProductImageUrl: [],
    multipleProductImageIds: [],
    productSpecification: currentProduct
      ? currentProduct.productSpecification
      : "",
    minIvtCap:
      currentProduct && currentProduct.inverterProduct
        ? currentProduct.inverterProduct.minIvtCap
        : "",
    batType:
      currentProduct && currentProduct.batType ? currentProduct.batType : "",
    batTypeValue:
      currentProduct && currentProduct.batTypeValue
        ? currentProduct.batTypeValue
        : "",
    installationFee: currentProduct ? currentProduct.installationFee : 0,
    buyerNote: currentProduct ? currentProduct.buyerNote : "",
    weight:
      currentProduct && currentProduct.weight
        ? handleStateChange4(String(currentProduct.weight))
        : "0",
    slug: currentProduct ? currentProduct.slug : "",
    shortDescription: currentProduct ? currentProduct.shortDescription : "",
    longDescription: currentProduct ? currentProduct.longDescription : "",
    monthlyFinancing: currentProduct ? currentProduct.monthlyFinancing : 0,
    productCode: currentProduct ? currentProduct.productCode : "",
    productDescription: currentProduct ? currentProduct.productDescription : "",
    productEnabled: currentProduct ? currentProduct.isEnable : false,
    isWarranty: currentProduct ? currentProduct.isWarranty : null,
    productCurrentPrice: currentProduct
      ? handleStateChange4(String(currentProduct.productCurrentPrice))
      : "0",
    productPreviousPrice: currentProduct
      ? handleStateChange4(String(currentProduct.productPreviousPrice))
      : "0",
    applyVat:
      currentProduct && currentProduct.applyVat
        ? currentProduct.applyVat
        : false,
    isDeliveryCarryOut: currentProduct
      ? currentProduct.isDeliveryCarryOut
      : null,
    productQuantity: currentProduct
      ? handleStateChange3(String(currentProduct.productQuantity))
      : "0",
  };

  const count = useRef(0);
  useEffect(() => {
    if (uuidValidate(productId)) {
      if (guidStatus !== "loading" && count.current === 0) {
        count.current = count.current + 1;
        fetchProductAsync(productId)
          .then(() => getProductCategories())
          .then(() => getProductBrands())
          .then(() => getInverterTypes())
          .finally(() => setGuidStatus(""));
        // .then(() => setIsEdit(true));
        // setImageUpload(currentProduct!.productImageUrl)
      }
    } else {
      navigate("/vendor/products");
    }
  }, [
    fetchProductAsync,
    getProductBrands,
    getProductCategories,
    guidStatus,
    navigate,
    productId,
    setGuidStatus,
    getInverterTypes,
  ]);
  return (
    <div className={styles.page}>
      {(guidStatus === "loading" || loading) && <Loading />}
      {modal === "success" && (
        <Modal
          variant="unstyled"
          style={{ position: "fixed", zIndex: "2" }}
          openModal={true}
          closeModal={() => navigate("/vendor/products")}
        >
          <div className={styles.verifyAccountModal}>
            {/* <h2>Activate Selling Permission</h2> */}

            <div className={styles.info}>
              {" "}
              <ThumbsUpSvg />
            </div>
            <div className={styles.welcomeText}>
              <p>Product Updated Successfully</p>
            </div>

            <div className={styles.twoButton}>
              <Button
                positive
                className={styles.modalactivate}
                onClick={() => navigate("/vendor/products")}
              >
                <div className={styles.button}>
                  <span>Okay!</span>
                </div>
              </Button>
            </div>
          </div>
        </Modal>
      )}

      <div className={styles.back}>
        <BackArrowSvg onClick={() => navigate("/vendor/products")} />
        <span>Go back</span>
      </div>
      <div className={styles.header}>Edit Product</div>
      <Formik
        initialValues={initialValues}
        enableReinitialize
        onSubmit={saveForm}
        validationSchema={vendorSchema.product}
      >
        {({
          dirty,
          errors,
          getFieldProps,
          handleSubmit,
          values,
          setFieldValue,
          isValid,
          isSubmitting,
        }) => {
          return (
            <Form onSubmit={handleSubmit}>
              <div className={styles.form}>
                <div className={styles.column1}>
                  <div className={styles.lone}>
                    <VendorInputTemp
                      inputType="text"
                      label={"Product name"}
                      mode="required"
                      placeholder={
                        currentProduct ? currentProduct.productName : ""
                      }
                      marginRight
                      {...getFieldProps("productName")}
                    />
                    <ErrorMessage
                      name={"productName"}
                      render={(error) => (
                        <Label basic color="red" content={error} />
                      )}
                    />
                  </div>
                  <div className={styles.flexForm}>
                    <div className={styles.marginRight}>
                      <SelectTemp
                        inputType="text"
                        label="Category"
                        mode="required"
                        placeholder={
                          categoryList &&
                          categoryList.length > 0 &&
                          categoryList[
                            categoryList.findIndex(
                              (x) => x.categoryId === values.categoryId
                            )
                          ]
                            ? categoryList[
                                categoryList.findIndex(
                                  (x) => x.categoryId === values.categoryId
                                )
                              ].category
                            : ""
                        }
                        options={
                          categoryList && categoryList.length > 0
                            ? [...categoryList]
                                .sort(function (x, y) {
                                  let a = x.category.toUpperCase(),
                                    b = y.category.toUpperCase();
                                  return a === b ? 0 : a > b ? 1 : -1;
                                })
                                .map((category, index) => ({
                                  key: String(index),
                                  label: category.category,
                                  value: category.categoryId,
                                }))
                            : []
                        }
                        value={values.categoryId}
                        onValueChange={(e: any) => {
                          setFieldValue("categoryId", e.value);
                        }}
                        name="categoryId"
                      />
                      <ErrorMessage
                        name={"categoryId"}
                        render={(error) => (
                          <Label basic color="red" content={error} />
                        )}
                      />
                    </div>
                    <div className={styles.marginLeft}>
                      <SelectTemp
                        inputType="text"
                        label="Brand"
                        placeholder={
                          values.brandId &&
                          brandsList &&
                          brandsList.length > 0 &&
                          brandsList.findIndex(
                            (x) => x.brandId === values.brandId
                          ) !== -1
                            ? brandsList[
                                brandsList.findIndex(
                                  (x) => x.brandId === values.brandId
                                )
                              ].brandName
                            : ""
                        }
                        options={
                          brandsList !== null
                            ? [...brandsList]
                                .sort(function (x, y) {
                                  let a = x.brandName.toUpperCase(),
                                    b = y.brandName.toUpperCase();
                                  return a === b ? 0 : a > b ? 1 : -1;
                                })
                                .map((brand, index) => ({
                                  key: String(index),
                                  label: brand.brandName,
                                  value: brand.brandId,
                                }))
                            : []
                        }
                        value={values.brandId}
                        onValueChange={(e: any) => {
                          setFieldValue("brandId", e.value);
                        }}
                        name="brandId"
                        // {...getFieldProps("categoryId")}
                      />
                      {/* <ErrorMessage
                        name={"brandId"}
                        render={(error) => (
                          <Label basic color="red" content={error} />
                        )}
                      /> */}
                    </div>
                  </div>
                  {categoryList &&
                    categoryList.length > 0 &&
                    categoryList.findIndex((category) => {
                      return (
                        category.category === "Inverters" &&
                        values.categoryId === category.categoryId
                      );
                    }) !== -1 && (
                      <div>
                        <div className={styles.marginRightsm}>
                          <SelectTemp
                            inputType="text"
                            label="Inverter Type"
                            placeholder={
                              values.batType &&
                              inverterTypesList &&
                              inverterTypesList.length > 0
                                ? inverterTypesList[
                                    inverterTypesList.findIndex(
                                      (x) => x.batteryInvtId === values.batType
                                    )
                                  ].batteryInvtName
                                : ""
                            }
                            options={
                              inverterTypesList !== null
                                ? [...inverterTypesList]
                                    .sort(function (x, y) {
                                      let a = x.batteryInvtName.toUpperCase(),
                                        b = y.batteryInvtName.toUpperCase();
                                      return a === b ? 0 : a > b ? 1 : -1;
                                    })
                                    .map((brand, index) => ({
                                      key: String(index),
                                      label: brand.batteryInvtName,
                                      value: brand.batteryInvtId,
                                    }))
                                : []
                            }
                            value={values.batType}
                            onValueChange={(e: any) => {
                              setFieldValue("batType", e.value);
                            }}
                            name="batType"
                            // {...getFieldProps("categoryId")}
                          />
                          <ErrorMessage
                            name={"batType"}
                            render={(error) => (
                              <Label basic color="red" content={error} />
                            )}
                          />
                        </div>
                        <div className={styles.flexForm}>
                          <div
                            className={`${styles.marginLeftsm} ${styles.marginRightsm}`}
                          >
                            <InputTemp
                              inputType="number"
                              label={"Minimum Inverter Capacity"}
                              placeholder={"Enter Capacity"}
                              marginRight
                              {...getFieldProps("minIvtCap")}
                            />
                            <ErrorMessage
                              name={"minIvtCap"}
                              render={(error) => (
                                <Label basic color="red" content={error} />
                              )}
                            />
                          </div>
                          <div className={styles.marginLeftsm}>
                            <InputTemp
                              inputType="number"
                              label={"Battery Type Value"}
                              mode="required"
                              placeholder={"Enter Type"}
                              marginRight
                              {...getFieldProps("batTypeValue")}
                            />
                            <ErrorMessage
                              name={"batTypeValue"}
                              render={(error) => (
                                <Label basic color="red" content={error} />
                              )}
                            />
                          </div>
                        </div>
                      </div>
                    )}
                  <div className={styles.textarea}>
                    <label htmlFor="">
                      Product Description <span className="required">*</span>
                    </label>
                    <MyTextArea
                      rows={3}
                      placeholder="..."
                      name="longDescription"
                      // {...getFieldProps("longDescription")}
                    />
                  </div>

                  <div className={styles.flexForm}>
                    <div className={styles.marginRight}>
                      <InputTemp
                        // inputType="number"
                        label={"Product Current Price"}
                        mode="required"
                        placeholder={"Enter Current Price"}
                        marginRight
                        {...getFieldProps("productCurrentPrice")}
                        inputType={"text"}
                        onChange={(e) =>
                                                  handleStateChange2(
                                                    setFieldValue,
                                                    "productCurrentPrice",
                                                    e
                                                  )
                                                }
                                                onBlur={(e) => handleStateDecimalToPrice(
                                                  setFieldValue,
                                                    "productCurrentPrice",
                                                    e)
                                                }
                      />
                      <ErrorMessage
                        name={"productCurrentPrice"}
                        render={(error) => (
                          <Label basic color="red" content={error} />
                        )}
                      />
                    </div>
                    <div
                      className={`${styles.marginLeft} ${styles.marginRight}`}
                    >
                      <InputTemp
                        // inputType="text"
                        label={"Product Previous Price"}
                        placeholder={"Enter Previous Price"}
                        marginRight
                        {...getFieldProps("productPreviousPrice")}
                        inputType={"text"}
                        onChange={(e) =>
                          handleStateChange2(
                            setFieldValue,
                            "productPreviousPrice",
                            e
                          )
                        }
                        onBlur={(e) => handleStateDecimalToPrice(
                          setFieldValue,
                            "productPreviousPrice",
                            e)
                        }
                      />
                      <ErrorMessage
                        name={"productPreviousPrice"}
                        render={(error) => (
                          <Label basic color="red" content={error} />
                        )}
                      />
                    </div>
                    <div className={styles.marginLeft}>
                      <InputTemp
                        // inputType="number"
                        label={"Product Quantity"}
                        mode="required"
                        placeholder={"Enter Quantity"}
                        marginRight
                        {...getFieldProps("productQuantity")}
                        inputType={"text"}
                        onChange={(e) =>
                          handleStateChange2(
                            setFieldValue,
                            "productQuantity",
                            e
                          )
                        }
                      />
                      <ErrorMessage
                        name={"productQuantity"}
                        render={(error) => (
                          <Label basic color="red" content={error} />
                        )}
                      />
                    </div>
                  </div>
                  <div className={styles.flexStart}>
                    <FormControlLabel
                      // disabled
                      control={<Checkbox checked={values.applyVat} />}
                      label="Apply VAT on Product"
                      style={{ padding: 0, marginRight: 50 }}
                      onClick={(e) => {
                        setFieldValue("applyVat", !values.applyVat);
                        setVat(!values.applyVat);
                      }}
                    />
                    <RadioGroup
                      row
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      name="row-radio-buttons-group"
                      value={values.isWarranty}
                    >
                      <span
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          marginRight: "20px",
                        }}
                      >
                        <label>Warranty</label>
                      </span>
                      <FormControlLabel
                        value={true}
                        control={<Radio />}
                        label="Yes"
                        onClick={() => setFieldValue("isWarranty", true)}
                      />
                      <FormControlLabel
                        value={false}
                        control={<Radio />}
                        label="No"
                        onClick={() => setFieldValue("isWarranty", false)}
                      />
                    </RadioGroup>
                  </div>
                </div>
                <hr className={styles.hr} />
                <div className={styles.column2}>
                  <label htmlFor="upload" className={styles.uploadlabel}>
                    Upload Pictures <span className="required">*</span>{" "}
                  </label>
                  <div className={styles.flexStart}>
                    {imageUpload.length > 0 &&
                      imageUpload.map((image, index) => {
                        const previewSrc = resolveImageSrc(image) ?? "";
                        return (
                          <div key={index}>
                            <UploadImageTemp
                              src={previewSrc}
                              onChange={(e) => imageHandler(e, index)}
                              btnText="Add Company Logo"
                              accept="image/*"
                            />
                          </div>
                        );
                      })}
                    {imageUpload.length < 5 && (
                      <div>
                        <UploadImageTemp
                          src={""}
                          onChange={(e) => imageHandler(e)}
                          btnText="Add Company Logo"
                          accept="image/*"
                        />
                      </div>
                    )}
                  </div>
                  <div className={styles.textarea2}>
                    <label htmlFor="">
                      Buyer’s Note (input in bullet points){" "}
                      <span className="required">*</span>{" "}
                    </label>
                    <MyTextArea
                      rows={3}
                      placeholder="Add your note"
                      // name="bio"
                      {...getFieldProps("buyerNote")}
                    />
                  </div>
                  <div className={styles.deliveryradio}>
                    <FormLabel id="demo-controlled-radio-buttons-group">
                      Would you like to carry out the delivery of this product?
                      <span className="required">*</span>
                    </FormLabel>

                    <RadioGroup
                      row
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      name="row-radio-buttons-group"
                      value={values.isDeliveryCarryOut}
                    >
                      <FormControlLabel
                        value={true}
                        control={<Radio />}
                        label="Yes"
                        onClick={() =>
                          setFieldValue("isDeliveryCarryOut", true)
                        }
                      />
                      <FormControlLabel
                        value={false}
                        control={<Radio />}
                        label="No"
                        onClick={() =>
                          setFieldValue("isDeliveryCarryOut", false)
                        }
                      />
                    </RadioGroup>
                  </div>
                  <div className={styles.marginRight}>
                    <InputTemp
                      // inputType="number"
                      label={"Shipping Weight(Kg)"}
                      mode="required"
                      placeholder={"Enter Weight"}
                      marginRight
                      {...getFieldProps("weight")}
                      inputType={"text"}
                      onChange={(e) =>
                        handleStateChange(setFieldValue, "weight", e)
                      }
                    />
                    <ErrorMessage
                      name={"weight"}
                      render={(error) => (
                        <Label basic color="red" content={error} />
                      )}
                    />
                  </div>
                </div>
              </div>
              <div className={styles.footer}>
                <div className={styles.searchAndFilter}>
                  <Button
                    positive
                    className={styles.bulkProduct}
                    type="submit"
                    disabled={!isValid || imageUpload.length === 0}
                    // onClick={() => navigate("/vendor/new-product")}
                  >
                    <div className={styles.positive}>
                      <span>Publish Product</span>
                      {/* <PlusCircle /> */}
                    </div>
                  </Button>
                </div>
              </div>
            </Form>
          );
        }}
      </Formik>
    </div>
  );
};

export default observer(UpdateProduct);
